import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useSelector } from 'react-redux';
import { useEffect } from 'react';
import { ServiceFactory } from '../services/ServiceFactory';
import { selectors as authSelectors } from '../store/slices/authSlice';

export const customerQueryKey = ['customer'];

const customerService = ServiceFactory.createCustomerService();

export const useCustomer = () => {
  const isLoggedIn = useSelector(authSelectors.isLoggedIn);
  const queryClient = useQueryClient();

  useEffect(() => {
    if (!isLoggedIn) {
      // Invalidate customer query when user is not logged in
      queryClient.invalidateQueries({ queryKey: customerQueryKey });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- Changes in the queryClient are irrelevant for this hook
  }, [isLoggedIn]);

  const { data, status, error } = useQuery({
    queryKey: customerQueryKey,
    queryFn: () => customerService.getCustomer(),
    enabled: isLoggedIn,
  });

  const isReady = !isLoggedIn || status !== 'pending';

  return {
    customer: data,
    status,
    error,
    isReady,
  };
};
